import React, { useEffect, useRef, useState } from "react";
import { Form } from "react-bootstrap";

const AutocompleteInput = ({
  value,
  onChange,
  options = [],
  placeholder = "",
  disabled = false,
  maxLength,
}) => {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const typed = (value || "").trim();
  const lowerTyped = typed.toLowerCase();
  const filtered = typed
    ? options.filter((o) => o.toLowerCase().includes(lowerTyped))
    : options;

  const showFreeTextFooter =
    typed.length > 0 &&
    !options.some((o) => o.toLowerCase() === lowerTyped);

  const pick = (val) => {
    onChange(val);
    setOpen(false);
  };

  return (
    <div className="autocomplete-input" ref={containerRef}>
      <Form.Control
        type="text"
        value={value || ""}
        placeholder={placeholder}
        disabled={disabled}
        maxLength={maxLength}
        onFocus={() => setOpen(true)}
        onChange={(e) => {
          onChange(e.target.value);
          setOpen(true);
        }}
        autoComplete="off"
      />

      {open && (filtered.length > 0 || showFreeTextFooter) && (
        <ul className="autocomplete-suggestions">
          {filtered.slice(0, 30).map((opt) => (
            <li
              key={opt}
              className="autocomplete-suggestion"
              onMouseDown={(e) => {
                e.preventDefault();
                pick(opt);
              }}
            >
              {opt}
            </li>
          ))}
          {showFreeTextFooter && (
            <li
              className="autocomplete-suggestion autocomplete-free-text"
              onMouseDown={(e) => {
                e.preventDefault();
                pick(typed);
              }}
            >
              Use "{typed}"
            </li>
          )}
        </ul>
      )}
    </div>
  );
};

export default AutocompleteInput;
